import React, {Component, useEffect, useState} from "react";
import {Divider, Grid, Loader, Segment, Table} from "semantic-ui-react"
import {NumericFormat} from 'react-number-format';
import BalanceChart from "./BalanceChart"
import BalanceSum from "./BalanceSum"
import CostCenters from "./CostCenters";
import {useNavigate} from "react-router";


function BalanceTable(props) {
    console.log("props", props)
    const months = props.balances.months;

    const balanceItems = months.map((month) =>
        <Table.Row key={month.month} textAlign='right'>
            <Table.Cell>{month.month}</Table.Cell>
            <Table.Cell><NumericFormat value={month.sum_ek_netto_total} displayType={'text'} thousandSeparator={true}
                                       prefix={'€'}/></Table.Cell>
            <Table.Cell><NumericFormat value={month.sum_vk_netto_total} displayType={'text'} thousandSeparator={true}
                                       prefix={'€'}/></Table.Cell>
            <Table.Cell><NumericFormat value={month.sum_operating_costs_netto_total} displayType={'text'}
                                       thousandSeparator={true} prefix={'€'}/></Table.Cell>
            <Table.Cell><NumericFormat value={month.db} displayType={'text'} thousandSeparator={true}
                                       prefix={'€'}/></Table.Cell>
        </Table.Row>
    );

    return (
        <Table celled striped>
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell>Monat</Table.HeaderCell>
                    <Table.HeaderCell>Sum EK Netto Total</Table.HeaderCell>
                    <Table.HeaderCell>Sum VK Netto Total</Table.HeaderCell>
                    <Table.HeaderCell>Sum Operating Costs Netto total</Table.HeaderCell>
                    <Table.HeaderCell>Deckungsbeitrag</Table.HeaderCell>
                </Table.Row>
            </Table.Header>
            <Table.Body>
                {balanceItems}
            </Table.Body>
        </Table>
    )
}

export default function BalanceOverview(props) {
    const [data, setData] = useState({
        balances: {
            months: [],
            overall_db:0,
            overall_ek_netto_total:0,
            overall_vk_netto_total:0,
            overall_operating_costs_netto_total:0
        },
        chartdata: [{
            x: "",
            y: 0,
            color: "",
            value: false
        }],
        loading: true,
    });
    const navigate = useNavigate()


    const fetchData = async () => {
        try {
            const url = API_URL + `/api/private/tanker/v1/balances/${props.year}`

            const token = sessionStorage.token
            if (!(token && token.length > 0)) navigate('/login')

            fetch(url, {headers: new Headers({'Authorization': `Bearer ${token}`})})
                .then(function (response) {
                    if (response.status >= 400) {
                        throw new Error("Bad response from server");
                    }
                    return response.json();
                })
                .then(function (data) {
                    let chartdata = []
                    let color
                    for (var m of data.months) {
                        if (m.db < 0) {
                            color = "red"
                        } else {
                            color = "green"
                        }
                        chartdata.push({x: m.month, y: parseFloat(m.db), color: color})
                    }

                    setData({balances: data, chartdata: chartdata, loading: false});
                });
        } catch (error) {
            console.error(error)
        }
    }

    useEffect(() => {
        document.title = `Balance ${props.year}`

        const token = sessionStorage.token
        if (!(token && token.length > 0)) {
            navigate("/login")
        }
        fetchData()
    }, [])

    return (
        <div>
            <Grid>
                <Grid.Column width={12}><BalanceChart chartdata={data.chartdata} year={props.year}/></Grid.Column>
                <Grid.Column width={4}><BalanceSum sum={data.balances.overall_db}/></Grid.Column>
            </Grid>
            <Divider/>
            <CostCenters year={props.year}/>
            <Divider/>
            <Table definition>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>Jahr</Table.HeaderCell>
                        <Table.HeaderCell>Overall EK Netto Total</Table.HeaderCell>
                        <Table.HeaderCell>Overall VK Netto Total</Table.HeaderCell>
                        <Table.HeaderCell>Overall Operating Costs Netto total</Table.HeaderCell>
                        <Table.HeaderCell>Overall Deckungsbeitrag</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    <Table.Row>
                        <Table.Cell>{data.balances.year}</Table.Cell>
                        <Table.Cell><NumericFormat value={data.balances.overall_ek_netto_total}
                                                   displayType={'text'} thousandSeparator={true} prefix={'€'}
                                                   decimalScale={2} fixedDecimalScale={true}/></Table.Cell>
                        <Table.Cell><NumericFormat value={data.balances.overall_vk_netto_total}
                                                   displayType={'text'} thousandSeparator={true} prefix={'€'}
                                                   decimalScale={2} fixedDecimalScale={true}/></Table.Cell>
                        <Table.Cell><NumericFormat value={data.balances.overall_operating_costs_netto_total}
                                                   displayType={'text'} thousandSeparator={true} prefix={'€'}
                                                   decimalScale={2} fixedDecimalScale={true}/></Table.Cell>
                        <Table.Cell><NumericFormat value={data.balances.overall_db} displayType={'text'}
                                                   thousandSeparator={true} prefix={'€'} decimalScale={2}
                                                   fixedDecimalScale={true}/></Table.Cell>
                    </Table.Row>
                </Table.Body>
            </Table>
            <BalanceTable balances={data.balances}/>
        </div>
    )
}


